import { render } from "./DashboardChartWithTable.vue?vue&type=template&id=388c2465&scoped=true"
import script from "./DashboardChartWithTable.vue?vue&type=script&lang=js"
export * from "./DashboardChartWithTable.vue?vue&type=script&lang=js"

import "./DashboardChartWithTable.vue?vue&type=style&index=0&id=388c2465&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388c2465"]])

export default __exports__